module.exports = __webpack_public_path__ + "static/media/Sleper_Vrijmeldenbaan_2.b12a9324.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/05/02/assets/Sleper_Vrijmeldenbaan_2.mp3
// module id = 563
// module chunks = 0